import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

interface SignPlanAddress {
	zipCode: string;
	street: string;
	number: string;
	complement?: string;
	district: string;
	city: string;
	state: string;
}

export interface SignPlanPayload {
	paymentMethod: 'credit_card' | 'pix';
	name: string;
	surName: string;
	document: string;
	documentType: string;
	phoneNumber: string;
	installments?: number;
	cardToken?: string;
	address: SignPlanAddress;
}

export const useSignPlan = () =>
	useMutation({
		mutationFn: async ({ planId, payload }: { planId: string; payload: SignPlanPayload }) => {
			try {
				return (await api.post(`/user/plan/sign/${planId}`, payload)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao assinar plano');
			}
		},
	});
